import type { ReactNode } from 'react'
import { Navigate } from 'react-router-dom'

import { LoadingSpinner } from '@/customer/components/loading-spinner'
import { PageContainer } from '@/customer/components/page-container'
import { useMemberBookingGuard } from '@/customer/hooks/use-member-booking-guard'
import { routes } from '@/customer/routes'

/**
 * Redirects to the account page when the member doesn't satisfy
 * member-level booking prerequisites (Stripe account, valid address,
 * verified phone, no overdue invoices).
 */
export function MemberBookingGuard({ children }: { children: ReactNode }) {
  const { isPending, eligible } = useMemberBookingGuard()

  if (isPending) {
    return (
      <PageContainer className="items-center justify-center">
        <LoadingSpinner />
      </PageContainer>
    )
  }

  if (!eligible) return <Navigate to={routes.account.index} replace />

  return children
}
